// extracted by mini-css-extract-plugin
export var timeToReadContainer = "bt_d2";
export var timerIcon = "bt_d3";